<template>
  <div class="slide zoom" ref="slide" v-parallax-fit="parallax"></div>
</template>

<script>
export default {
  name: 'slide23',
  data() {
    return {
		mutationObserver: null,
      parallax: [
        {
          start: 29300,
          end: 29800,
          fromStyle: {transform: 'translateY(-1350px) rotateZ(15deg)'},
          toStyle: {transform: 'translateY(0px) rotateZ(3deg)'},
          easing: 'linear'
        },
        {
          start: 30600,
          end: 31300,
          fromStyle: {transform: 'translateY(0px) rotateZ(3deg)'},
          toStyle: {transform: 'translateY(1500px) rotateZ(25deg)'},
          easing: 'linear'
        },
      ]
    };
  },
  mounted() {
    const evidence = {
      items: [
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/vanessa/evidence/13_14a.jpg',
          url: 'https://d3n8a8pro7vhmx.cloudfront.net/acceinstitute/pages/1153/attachments/original/1570049936/WallstreetLandlordsFinalReport.pdf?1570049936',
          link_title: {
			'en': 'Wall Street Landlords turn American Dream into a Nightmare',
			'es': 'Los propietarios de Wall Street convierten el sueño americano en una pesadilla'
		  }
        },
      ],
      text: {
		'en': '“When houses are sold to cash-carrying investors for conversion into rentals... communities suffer — particularly communities of color. Wall Street landlords are accountable to investors to increase profits...tenants are negatively impacted, with large annual rent increases, fee gouging, a high rate of evictions, and rampant habitability issues. Federal government policies have spurred the trends discussed here...most of these large institutionalized companies are receiving a huge tax break, being exempt from federal taxes due to their status as Real Estate Investment Trusts (REITs).”',
		'es': '“Cuando las casas se venden a inversionistas que llevan dinero en efectivo para convertirlas en alquileres... las comunidades sufren, particularmente las comunidades de color. Los propietarios de Wall Street son responsables ante los inversionistas para aumentar las ganancias... los inquilinos se ven afectados negativamente, con grandes aumentos anuales de alquiler, aumento de tarifas, una alta tasa de desalojos y problemas de habitabilidad desenfrenados. Las políticas del gobierno federal han estimulado las tendencias discutidas aquí... la mayoría de estas grandes empresas institucionalizadas están recibiendo una gran exención de impuestos, ya que están exentas de impuestos federales debido a su condición de fondos de inversión en bienes raíces (REIT, por sus siglas en inglés)”'
	  }
    };
    const text = {
		'en': 'Renting from Wall Street would prove to be more of an agony than security. Unfortunately, Vanessa and her family\'s experience renting from a large corporate landlord is not an outlier and speaks to the experiences of many other beguiled renters, particularly over the last ten years.',
		'es': 'Alquilar en Wall Street demostraría ser más una agonía que una seguridad. Desafortunadamente, la experiencia de Vanessa y su familia alquilando a un gran propietario corporativo no es atípica y habla de las experiencias de muchos otros inquilinos engañados, particularmente durante los últimos diez años.'
	};
    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach(mutation => {
        if (mutation.target.style.transform == 'translateY(0px) rotateZ(3deg)') {
          this.$readMore.value = text;
          this.$evidence.value = JSON.stringify(evidence);
        }
      });
    });

    this.mutationObserver.observe(this.$refs.slide, {
      attributes: true,
      attributeFilter: ['style']
    });

  },
  unmounted() {
    this.mutationObserver.disconnect();
  },
}
</script>

<style lang="scss" scoped>
.slide {
    position: fixed;
    transform-origin: center;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/23_NYT_Article.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 940px;
    height: 650px;
    left: calc(50% - 250px);
    top: calc(50% - 264px);
    transition: 0.5s;
    z-index: 7;
    @media(max-width: 600px) {
      width: 90vw;
      left: -34vw;
    }
}
</style>
